import { useState, memo } from 'react'
import HeaderSpan from './HeaderSpan'
import SpeedItem from './SpeedItem'
import { langSpeedList } from '../assets/langSpeedList'
import { useLang } from '../utils/hooks'

const SpeedList = ({
  listeSpeed,
  handleSelectNewSpeedItem,
  kind,
  textClass,
}) => {
  const background = 'has-background-info-light mr-2'
  const { lang } = useLang()
  const choosenLang = lang === 'fr' ? langSpeedList.fr : langSpeedList.eng
  const [selectedItemIndexes, setSelectedItemIndexes] = useState({
    itemIndex: -1,
    oldItemIndex: -1,
  })

  const w_a = ['40', '60']
  let i = 0
  let row_i = 0

  const handleClickOnItem = (itemIndex) => {
    const oldItemIndex = selectedItemIndexes.itemIndex
    if (itemIndex === oldItemIndex) {
      listeSpeed[itemIndex].bg = ''
      itemIndex = -1
    } else {
      if (itemIndex !== -1) {
        listeSpeed[itemIndex].bg = 'selected'
      }
      if (oldItemIndex !== -1) {
        listeSpeed[oldItemIndex].bg = ''
      }
    }
    setSelectedItemIndexes({ itemIndex, oldItemIndex })
    handleSelectNewSpeedItem(
      itemIndex,
      itemIndex !== -1 ? listeSpeed[itemIndex].timeU : 0,
      itemIndex !== -1 ? listeSpeed[itemIndex].speed : 0,
      kind,
    )
  }

  const onHeaderClick = () => {
    //just to avoid error
  }

  return (
    <div className="mr-3 ml-3">
      <div className="block">
        <div>
          <span>{choosenLang.title}</span>
        </div>
      </div>
      <div className={'block ' + textClass}>
        <div style={{ display: 'flex' }}>
          <HeaderSpan
            headerTitle={choosenLang.time}
            background={background}
            columnType={''}
            sortType={'SPEED_MAX_GPS_SPEED'}
            sortOrder={true}
            w={w_a[i]}
            handleOnClick={onHeaderClick}
            align={'left'}
          />
          <HeaderSpan
            headerTitle={choosenLang.speed}
            background={background}
            columnType={'SPEED_MAX_GPS_SPEED'}
            sortType={'SPEED_MAX_GPS_SPEED'}
            sortOrder={true}
            w={w_a[++i]}
            handleOnClick={onHeaderClick}
            align={'left'}
          />
        </div>
      </div>
      <div className="block">
        {listeSpeed.map((oneSpeed, index) => {
          row_i++
          return (
            <SpeedItem
              id={row_i - 1}
              key={index}
              oneSpeed={oneSpeed}
              onClick={handleClickOnItem}
              // isGrey={row_i % 2 === 1}
              isGrey={true}
              isSelected={oneSpeed.bg}
              wA={w_a}
            />
          )
        })}
      </div>
    </div>
  )
}

export default memo(SpeedList)
